import { Component, OnDestroy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { GlobalAppService } from '@app/Modules/Shared/Services/global-app.service';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '@app/Modules/Shared/Services/app.service';
import { HttpService } from '@app/Modules/Shared/Services/http.service';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';

@AutoUnsubscribe()

@Component({
  selector: 'd2dfile-download',
  templateUrl: './d2dfile-download.component.html',
  styleUrls: ['./d2dfile-download.component.scss']
})
export class D2DFileDownloadComponent implements AgRendererComponent, OnDestroy {

  params: any;
  documentId: any;
  subscription: Subscription = new Subscription();
  language: string;
  region: string;
  paramsValue: string;
  LCIDString: any;
  downloadLink: any;
  showNotification: boolean = false;

  constructor(
    private httpServ: HttpService,
    private _globalAppService: GlobalAppService,
    private translateServ: TranslateService,
    private appServ: AppService,
    private messageService: MessageService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  agInit(params: any): void {
    this.params = params;
    this.paramsValue = params.value;
    
  }

  autoDownloadFile(reportId) {
    if (this.params && this.params.data && this.params.data.fileName) {
      this.makeAPICall(this.params.data.fileName);
    }
  }

  notify(e) {
    this.showNotification = true;
    setTimeout(() => {
      this.showNotification = false;
    }, 2000);
  }

  setLanguageListener() {
    this.translateServ.get(['LCIDString'])
      .subscribe(value => {
        if (value) {
          this.LCIDString = value.LCIDString;
        }
      });
  }

  refresh(params: any): boolean {
    return false;
  }

  onLinkClick(event) {
    this.makeAPICall(event);
  }

  makeAPICall(event) {
    
    if (this.params.data && this.params.data.fileName) {
      this.appServ.setLoadingStatus(true);
      let fileversion = 1;
      let request = {
        "d2DFileName": this.params.data.fileName,
        "fileversion": fileversion //passing fileversion as 1 as new file to be downloaded code is 1 and for old its 0
      }
      this.subscription.add(this.httpServ.d2DfileDownload(request).subscribe((res) => 
        {
          if (res && res.fileUrl) {
           window.open(res.fileUrl, '_blank');       
        }
          else{
            this.appServ.setLoadingStatus(false);
            this.messageService.add({ key: 'downloadError', detail: '0000.errorMessage', summary: 'errorLabel', severity: 'error' })
          }
        },
        (e) => {
          this.appServ.setLoadingStatus(false);
          this.messageService.add({ key: 'downloadError', detail: '0000.errorMessage', summary: 'errorLabel', severity: 'error' })
        },
        () => {
          this.appServ.setLoadingStatus(false)
          if(this.subscription){
            this.subscription.unsubscribe();
          }
        })
      );
    }

    
  }

  ngOnDestroy() {
    // Required for unsubscribing and destroying the component  
    if(this.subscription){
      this.subscription.unsubscribe();
    }
  }

}
